import React, { FormEvent } from 'react'
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util'

import { StyledToggleFieldset } from './toggle-component.styles'
import { Toggle as ATDSToggle } from '@at/design-system-elements'

interface OptionsPropsType {
    displayValue: string
    value: string
    selected?: boolean
    disabled?: boolean
}

interface TogglePropsType {
    id: string
    name: string
    labelText?: string
    helpText?: string
    options: Array<OptionsPropsType>
    value?: string
    modifierClass?: string
    defaultField?: boolean
    onChange: (evt: FormEvent<HTMLInputElement>) => void
}

export const Toggle = ({ id, name, labelText, helpText, options, modifierClass = '', onChange }: TogglePropsType) => {
    const anySelected = options.some((o) => o.selected)

    const toggleBar = (
        <ATDSToggle
            className="search-filters-toggle"
            options={options.map((opt, i) => {
                const defaultSelection = !anySelected && i === 0
                return {
                    label: opt.displayValue,
                    value: opt.value,
                    selected: opt.selected || defaultSelection,
                    disabled: false,
                }
            })}
            id={id}
            name={name}
            onChange={(e) => onChange(e)}
            helpText={helpText}
            legendText={labelText}
        />
    )

    if (!!labelText) {
        return (
            <StyledToggleFieldset className={conditionalClassList('toggle-field', modifierClass)}>
                {toggleBar}
            </StyledToggleFieldset>
        )
    } else {
        return toggleBar
    }
}
